var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import "react-tooltip/package.json";
import classNames from 'classnames';
var timeoutDuration = 150;
export function Tooltip(_a) {
    var children = _a.children, tooltipContent = _a.tooltipContent, attachmentPoint = _a.attachmentPoint, idProp = _a.id, className = _a.className, other = __rest(_a, ["children", "tooltipContent", "attachmentPoint", "id", "className"]);
    var id = useMemo(function () { return idProp || "tooltip-".concat(Date.now()).concat(Math.random()); }, [idProp]);
    var place = useMemo(function () {
        switch (attachmentPoint) {
            default:
            case "top left":
                return "top-start";
            case "top":
                return "top";
            case "top right":
                return "top-end";
            case "left":
                return "left";
            case "right":
                return "right";
            case "bottom left":
                return "bottom-start";
            case "bottom":
                return "bottom";
            case "bottom right":
                return "bottom-end";
        }
    }, [attachmentPoint]);
    return React.createElement(React.Fragment, null,
        React.createElement("span", __assign({ "data-tooltip-id": id, tabIndex: 0, className: classNames('select-none', className) }, other), children),
        React.createElement(ReactTooltip, { delayHide: timeoutDuration, id: id, place: place, disableStyleInjection: "core", className: 'shadow-lg text-white bg-gray-900 absolute z-10 transform py-2 px-3 font-semibold text-xs rounded-lg max-w-sm h-min w-max border border-gray-900 transition-opacity', classNameArrow: 'text-gray-900 absolute' }, tooltipContent));
}
